import { FC, ReactNode } from 'react';
import { Box, Divider, Svg, Text, Timeline } from '@hopskipdrive/react-components';
import { colorPalette } from '@rideiq/shared/components/variables';

interface DriverEventProps {
  title: string;
  isLast?: boolean;
  isComplete: boolean;
  formattedTime: string;
  timeDifference?: ReactNode;
}

export const DriverEvent: FC<DriverEventProps> = ({
  title,
  isLast = false,
  isComplete,
  formattedTime,
  timeDifference,
}) => {
  return (
    <Timeline.Item
      dotContent={<Timeline.SolidDot isComplete={isComplete} />}
      connector={!isLast && <Timeline.SolidConnector $strokeColor={isComplete ? colorPalette.green90 : ''} />}
    >
      <Box mb={5} display="flex" flexDirection="row" justifyContent="space-between">
        <Text textColor="secondaryText">{title}</Text>
        <Box display="flex" alignItems="center" gap="8px">
          {timeDifference}
          {isComplete && <Svg icon="checkmark-stroke" width={12} />}
          <Text textColor="secondaryText">{formattedTime}</Text>
        </Box>
      </Box>
      {!isLast && <Divider bgColor="#F0F5FA" opacity={0.5} mt={5} mb={5} />}
    </Timeline.Item>
  );
};
